import {
  MultiSelector,
  MultiSelectorContent,
  MultiSelectorInput,
  MultiSelectorItem,
  MultiSelectorList,
  MultiSelectorTrigger,
} from '../../ui/multiselect'

const convertOptionsToObject = (
  options: { value: string; label: string }[]
) => {
  return options.reduce((acc, option) => {
    acc[option.value] = option.label
    return acc
  }, {} as { [key: string]: string })
}

export function MultiselectField ({
  options,
  handleChange,
  value,
}: {
  options: { value: string; label: string }[];
  handleChange: (value: string[]) => void;
  value: string[];
}) {
  return (
    <MultiSelector
      onValuesChange={handleChange}
      values={value}
      valueToLabelMap={convertOptionsToObject(options)}
      loop
    >
      <MultiSelectorTrigger>
        <MultiSelectorInput placeholder='Select metal tier..' />
      </MultiSelectorTrigger>
      <MultiSelectorContent>
        <MultiSelectorList>
          {options.map((option) => (
            <MultiSelectorItem key={option.value} value={option.value}>
              <span>{option.label}</span>
            </MultiSelectorItem>
          ))}
        </MultiSelectorList>
      </MultiSelectorContent>
    </MultiSelector>
  )
}
